export default "__VITE_ASSET__DEjr9hEz__"